import { START_LOADER, STOP_LOADER } from '../actionTypes';

const initialState = {
  isShow: false
};

export default function (state = initialState, action=null) {
  switch (action.type) {
    case START_LOADER:
      return {
        isShow: true,
      };

    case STOP_LOADER:
      return {
        isShow: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/loader.js